import React from 'react';
import HBButton from '@honeybook/hbui/dist/components/HBButton/HBButton';
import HBModal from '@honeybook/hbui/dist/components/HBModal/HBModal';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import colors from '@honeybook/hbui/dist/styles/colors';
import TriangleExclamationMark42 from '@honeybook/icons/dist/icons/TriangleExclamationMark42';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';

type Props = {
    isOpen: boolean;
    closeDeactivateModal: () => void;
    deactivateLink: () => Promise<void>;
};

export const DeactivatePublicTemplateModal = ({
    isOpen,
    closeDeactivateModal,
    deactivateLink
}: Props) => {
    const { t: tPublish } = useTranslation(NAMESPACES.TEMPLATES, {
        keyPrefix: 'share_template.publish_template'
    });

    return (
        <HBModal isOpen={isOpen} onClose={closeDeactivateModal} hideCloseButton>
            <DeactivateModalContent>
                <TriangleExclamationMark42 color={colors.neutral900} />
                <DeactivateModalText>
                    <HBText type="title18" align="center">
                        {tPublish('deactivate_modal.title')}
                    </HBText>
                    <HBText type="body14" align="center">
                        {tPublish('deactivate_modal.description')}
                    </HBText>
                </DeactivateModalText>
                <DeactivateModalActions>
                    <HBButton
                        id="cancel_cta"
                        onClick={closeDeactivateModal}
                        buttonTheme="secondary-invisible-primary"
                    >
                        {tPublish('deactivate_modal.cancel_cta')}
                    </HBButton>
                    <HBButton
                        id="confirm_cta"
                        onClick={deactivateLink}
                        buttonTheme="secondary-solid-destructive"
                    >
                        {tPublish('deactivate_modal.confirm_cta')}
                    </HBButton>
                </DeactivateModalActions>
            </DeactivateModalContent>
        </HBModal>
    );
};

const DeactivateModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 284px;
    align-items: center;
`;

const DeactivateModalText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
`;

const DeactivateModalActions = styled.div`
    display: flex;
    gap: 12px;
`;
